import { useParams } from 'react-router-dom';
import { useRef, useState, useEffect } from 'react';
import { useCart } from '../Context/CartContext';
import { toast } from 'react-toastify';
import '../Components/Styles/articles.css';
import { FaTruck, FaLock, FaSmile, FaHeadset } from 'react-icons/fa';

function formatPoids(poids, unite) {
  if ((unite === 'g' || unite === 'ml') && poids >= 1000) {
    const valeur = poids / 1000;
    const nouvelleUnite = (unite === 'g') ? 'kg' : 'L';
    return `${parseFloat(valeur.toFixed(2))} ${nouvelleUnite}`;
  }

  const noPluralUnits = ['g', 'kg', 'ml', 'L'];

  if (poids === 1) {
    if (!noPluralUnits.includes(unite) && unite.endsWith('s')) {
      unite = unite.slice(0, -1);
    }
  } else {
    if (!noPluralUnits.includes(unite) && !unite.endsWith('s')) {
      unite = unite + 's';
    }
  }

  return `${poids} ${unite}`;
}

function getIconName(i) {
  const icons = ["dumbbell", "dog-bone", "shield", "lightning-bolt"];
  return icons[i % icons.length];
}



function ProductPage() {
  const { productId } = useParams();
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [poidsIndex, setPoidsIndex] = useState(0);
  const [goutIndex, setGoutIndex] = useState(0);
  const { addToCart, stockError, setStockError } = useCart();
  const [mainImage, setMainImage] = useState('');

  const [promos, setPromos] = useState([]);

  const imagesContainerRef = useRef(null);
  const [showScrollButton, setShowScrollButton] = useState(false);

  useEffect(() => {
    const container = imagesContainerRef.current;
    if (container) {
      const hasOverflow = container.scrollHeight > container.clientHeight;
      setShowScrollButton(hasOverflow);
    }
  }, [product]);

  const scrollDown = () => {
    if (imagesContainerRef.current) {
      imagesContainerRef.current.scrollBy({
        top: 100,
        behavior: "smooth",
      });
    }
  };

  useEffect(() => {
    fetch('/api/promotions.php?action=all')
      .then(res => res.json())
      .then(data => setPromos(data))
      .catch(err => console.error("Erreur fetch promos:", err));
  }, []);

  useEffect(() => {
    setLoading(true);
    setError(null);

    fetch(`/api/products.php?id=${productId}`)
      .then(res => {
        if (!res.ok) throw new Error(`Erreur HTTP ${res.status}`);
        return res.json();
      })
      .then(data => {
        if (data.error) throw new Error(data.error);

        if (typeof data.imagesSecondaires === 'string') {
          try {
            data.imagesSecondaires = JSON.parse(data.imagesSecondaires);
          } catch (e) {
            console.error('Erreur de parsing JSON sur imagesSecondaires', e);
            data.imagesSecondaires = [];
          }
        }

        setProduct(data);
        setMainImage(data.image || '');
        setLoading(false);
      })
      .catch(err => {
        setError(err.message);
        setLoading(false);
      });
  }, [productId]);

  if (loading) return <p>Chargement du produit...</p>;
  if (error) return <p>Erreur : {error}</p>;
  if (!product) return <h2>Produit introuvable</h2>;
  if (!product.variantes || product.variantes.length === 0) return <p>Produit incomplet</p>;

  const selectedVariante = product.variantes[goutIndex] || {};
  const selectedOption = selectedVariante.option?.[poidsIndex] || {};
  console.log(selectedOption.stock);
  
  const price = Number(selectedOption.prix || 0);

  const selectedPromo = promos.find(
    p => p.variante_option_id === selectedOption.id
  );
  const prixReduit = selectedPromo
  ? selectedPromo.type_reduction === 'pourcentage'
    ? (price * (1 - selectedPromo.valeur / 100)).toFixed(2)
    : (price - selectedPromo.valeur).toFixed(2)
  : null;

  const images = Array.isArray(product.imagesSecondaires) ? product.imagesSecondaires : [];

  const handlePoidsChange = (e) => setPoidsIndex(parseInt(e.target.value));
  const handleGoutChange = (e) => setGoutIndex(parseInt(e.target.value));

  const getImageUrl = (imageName) => `/static/media/${imageName}`;

  console.log('Produit reçu :', product);
  return <>
    <div className="produits-container">
      <div className='bs-container'>
        <div className="img-container">
          <div className="images-bis-wrapper">
            <div className="images-bis" ref={imagesContainerRef}>
              {images.map((imgName, index) => (
                <img key={index} src={getImageUrl(imgName)} alt={`${product.nom} secondaire ${index + 1}`} width={100} onClick={() => setMainImage(imgName)} style={{ cursor: 'pointer' }}/>
              ))}
            </div>
            
          </div>
          <div className="main-image">
            {mainImage ? (
              <img src={getImageUrl(mainImage)} alt={product.nom} />
            ) : (
              <p>Image non disponible</p>
            )}
          </div>
        </div>
        <div className="bs-container-description">
          <h1 className='bs-container-title'>{product.nom}</h1>
          {stockError && (
            <div className="custom-alert">
              {stockError}
              <button onClick={() => setStockError(null)}>X</button>
            </div>
          )}
          <div className="bs-container-desc">
            <p className='bs-price'>
              Prix : {prixReduit ? `${prixReduit} €` : `${price.toFixed(2)} €`}
              {prixReduit && (
                <span style={{ textDecoration: 'line-through', color: '#999', marginLeft: '8px' }}>
                  {price.toFixed(2)} €
                </span>
              )}
            </p>
            <div className="container-poids-gout">
              {product.variantes.length > 1 && product.variantes[0].gout && (
                <div className='option-produit'>
                  <label className='option-title'>Goût : </label>
                  <select className='selected-weight' value={goutIndex} onChange={handleGoutChange}>
                    {product.variantes.map((v, i) => (
                      <option className='selected-option' key={i} value={i}>
                        {v.gout}
                      </option>
                    ))}
                  </select>
                </div>
              )}
              <div className='option-produit'>
                <label className='option-title'>Quantité : </label>
                <select className='selected-weight' value={poidsIndex} onChange={handlePoidsChange}>
                  {(selectedVariante.option || []).map((opt, i) => (
                    <option className='selected-option' key={i} value={i}>
                      {formatPoids(opt.poids, product.unite)}
                    </option>
                  ))}
                </select>
              </div>
              <button
                className='add-cart-btn'
                disabled={selectedOption.stock <= 0}
                onClick={async () => {
                  console.log('selectedOption:', selectedOption);
                  console.log('variante_option_id:', selectedOption.id);
                  const selectedProduct = {
                    product_id: product.id,
                    variante_option_id: selectedOption.id,
                    nom: product.nom,
                    poids: selectedOption.poids,
                    gout: selectedVariante.gout,
                    quantity: 1,
                    price: prixReduit ? Number(prixReduit) : selectedOption.prix,
                    image: product.image,
                    unite: product.unite,
                  };
                  const success = await addToCart(selectedProduct);
                  if (success) {
                    toast.success(`${product.nom} a été ajouté au panier !`, {
                      position: 'top-right',
                      autoClose: 2000,
                      hideProgressBar: false,
                      closeOnClick: true,
                      pauseOnHover: true,
                      draggable: true,
                      theme: 'light',
                    });
                  }
                }}
              >
                Ajouter au panier
              </button>
            </div>
            {selectedOption.stock > 0 ? (
              <div className="stock-badge">
                {selectedOption.stock === 1
                  ? "Dernier article disponible !"
                  : `Il ne reste que ${selectedOption.stock} articles`}
              </div>
            ) : (
              <div className="stock-badge out-of-stock">Rupture de stock</div>
            )}
          </div>
        </div>
      </div>
      <div className="banner-container">
        <div className="banner-item">
          <FaTruck size={48} color="#ffffffff" />
          <span>Livraison rapide 24/48h</span>
        </div>
        <div className="banner-item">
          <FaLock size={48} color="#ffffffff" />
          <span>Paiement sécurisé</span>
        </div>
        <div className="banner-item">
          <FaSmile size={48} color="#ffffffff" />
          <span>Satisfait ou remboursé</span>
        </div>
        <div className="banner-item">
          <FaHeadset size={48} color="#ffffffff" />
          <span>Support client disponible</span>
        </div>
      </div>
      <div className="info-desc-sup">
        {product.description && (
          <div className="product-description">
            <h4>Description</h4>
            <p>{product.description}</p>
          </div>
        )}
        <div className="info-sup">
          {Array.isArray(product.info_supp) && product.info_supp.length > 0 && (
            <div className="extra-info">
              <h4>Informations supplémentaires :</h4>
              <div className='list-ul-ei'>
                {product.info_supp.map((info, i) => (
                  <div className='list-li-ei' key={i}>• {info}</div>
                ))}
              </div>
            </div>
          )}
          {/* Icônes */}
          {Array.isArray(product.icones) && product.icones.length > 0 && (
            <div className="icon-section">
              {product.icones.map((text, i) => (
                <div className="icon-box" key={i}>
                  <img src={`https://img.icons8.com/color/48/${getIconName(i)}.png`} alt="" />
                  <span>{text}</span>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  </>
}

export default ProductPage;